import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import { getClientList, doClientDelete } from "../../../../redux/client/clientState";
import { handleTableChange, contactDetailName } from "../../../../utils/index";
import PopupButton from "components/button/PopupButton";
import ClientForm from "./ClientForm";
import Badge from "components/badge";
import { CLIENT_STATUS_COLORS } from "../../../../variables/constants";
import SearchFilter from "components/search/SearchFilter";

const ClientTable = ({ 
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete 
}) => {


  	const columns = [
		{
	        title: `Name`,
	        dataIndex: 'clt_name',
	        key: 'clt_name',
	        width: '40%',
	        render:(clt_name) => <span>{clt_name}</span> 
	    },	
		{
	        title: `Contact`,
	        dataIndex: 'contact_details',
	        key: 'contact_details',
	        width: '25%',
	        render:(contact_details) => <span>{contactDetailName(contact_details)}</span> 
	    },		
		{
	        title: `Status`,
	        dataIndex: 'clt_status_name',
	        key: 'clt_status_name',
	        width: '15%',
			render: (clt_status_name) => (
				<Badge color={CLIENT_STATUS_COLORS[clt_status_name]}>
					<span>{clt_status_name}</span>
				</Badge>
			)
	    },
	    {
	        title: <PopupButton id="add_client" title="Add Client" label="Add" btnClass="btn-small">
						<ClientForm recordId="0" mode="edit" />
					</PopupButton>,
	        dataIndex: 'clt_id',
	        key: 'clt_id',
	        width: '10%',
	        render:(clt_id) => <CrudOption 
									baseRoute="/console/clients" 
									recordId={clt_id} 
									deleteHandler={doDelete} 
									allowEdit={false}
									// editMode="modal"
									// title="Edit Client"
									// editHandler={(clt_id) => (<ClientForm recordId={clt_id} mode="edit" />)}
								/>
	    },
    ];
    
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
			<div className="py-2">
				<SearchFilter 
					placeholder="Search by Client Name" 
					searchHandler={doSearch} 
					filters={filters} 
					pagination={pagination}
				/>
			</div>
			
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.clt_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
		            onChange={handleTableChange(doSearch, filters)}                  	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.client.clientList?.items,
	pagination: state.client.clientList?.pagination,
	filters: state.client.clientList?.filters,
  	requesting: state.client.clientList?.requesting,
  	error: state.client.clientList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getClientList(filters)),
  	doDelete: (id) => dispatch(doClientDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientTable);